export const DETAILS_API_ENDPOINTS = {
    DETAILS: '/flight/orchestrator/v2/flight/details',
    WALLET_SERVICE: '/flight/orchestrator/v2/wallet'
}
